export const ENV = {
  API_ROOT: "/api", //"https://dev-api.EDataBank.com/api", //
  APP_NAME:"ESOCS Data Bank"
};
